module.exports = __webpack_public_path__ + "img/_MG_8710.c345c906.jpg";